import { styled, CircularProgress, Typography } from "@mui/material";
const StyledProgressCircleContainer = styled("div")(() => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "max-content"
})), StyledCircularProgress = styled(CircularProgress)(({ theme }) => ({
  zIndex: 1,
  borderRadius: "10%",
  strokeLinecap: "round",
  ".MuiCircularProgress-colorSecondary": {
    color: theme.palette.secondary[900]
  },
  ".MuiCircularProgress-colorPrimary": {
    color: theme.palette.primary[900]
  }
})), StyledCircularProgressBar = styled(CircularProgress)(
  ({ theme }) => ({
    color: theme.palette.grey[400],
    position: "absolute"
  })
), StyledProgressCircleValue = styled(Typography)(({ theme }) => ({
  position: "absolute",
  color: theme.palette.grey[500]
}));
export {
  StyledCircularProgress,
  StyledCircularProgressBar,
  StyledProgressCircleContainer,
  StyledProgressCircleValue
};
//# sourceMappingURL=styles.js.map
